import { render } from "./forgot-email.vue?vue&type=template&id=687632ca&scoped=true"
import script from "./forgot-email.vue?vue&type=script&lang=js"
export * from "./forgot-email.vue?vue&type=script&lang=js"

import "./forgot-email.vue?vue&type=style&index=0&id=687632ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-687632ca"]])

export default __exports__